import { createElement, Component, Props as ReactProps } from 'react';
import { DependencyProps } from '../../core/dependency';
import { LocationProps } from '../../core/location';
import { StateProps } from '../../core/state';
import ContentSelectForm from '../components/organisms/ContentSelectForm';
import Sider from '../components/organisms/ContentSelectForm/Sider';
import SiderFrame from '../components/templates/SidebarFrame';
import { SearchProductType } from '../../state/contentSelect';
import Order from '../../entity/order';
import Store from '../../entity/store';
import * as _ from 'lodash';
import {
  Modal,
} from "antd";
import PageInfo from "../../entity/pageInfo";
import OrderProduct from "../../entity/orderProduct";

type Props = ReactProps<HTMLDivElement> &
  DependencyProps &
  StateProps &
  LocationProps;

class ContentSelectRoute extends Component<Props, {}> {
  constructor(props: Props) {
    super(props);

    this.updateOrderProductField = this.updateOrderProductField.bind(this);
    this.productNextPage = this.productNextPage.bind(this);
    this.productSearchChanged = this.productSearchChanged.bind(this);
    this.productSearchChanged = _.debounce(this.productSearchChanged, 100);
    this.save = this.save.bind(this);
    this.autoSave = this.autoSave.bind(this);
    this.autoSave = _.debounce(this.autoSave, 500);
  }

  public componentWillMount() {
    this.initialize(this.props);
  }

  public componentWillUnmount() {
    this.dispose(this.props);
  }

  public render() {
    const { dependency, location, state } = this.props;
    const {
      order,
      orderProducts,
      products,
      productCategories,
      productSearchParams,
      productPageInfo,
      fetches,
    } = state.contentSelect;
    const currentStore = state.currentStore;
    if (!currentStore) {
      return null;
    }

    const summaries = <ContentSelectForm
        products={products}
        orderProducts={orderProducts}
        updateOrderProductField={this.updateOrderProductField}
        productNextPage={this.productNextPage}
        productPageInfo={productPageInfo}
      />;

    const sider = <Sider
        order={order || new Order({})}
        productCategories={productCategories}
        updateSearchProduct={this.productSearchChanged}
        searchProduct={productSearchParams}
        save={this.save}
      />;

    return <SiderFrame
      {...{ dependency, location, state }}
      content={summaries}
      sidebar={sider}
      isSpinner={fetches === 1}
    />;
  }

  private async initialize(props: Props) {
    try {
      await props.dependency.contentSelect.initialize();
    } catch (err) {
      window.console.error(err);
    }
  }

  private updateOrderProductField(orderProduct: OrderProduct, count: number) {
    this.props.dependency.contentSelect.updateEditOrderProductField(orderProduct, count);
    this.autoSave();
  }

  private async save() {
    try {
      const store = this.props.state.currentStore as Store;
      await this.props.dependency.contentSelect.save();
      window.location.href = store.cartUri;
    } catch (e) {
      Modal.error({
        title: '保存に失敗',
        content: <div>
          <div>保存に失敗しました。</div>
          <div>{e.message}</div>
        </div>,
      });
    }
  }

  private async autoSave() {
    try {
      await this.props.dependency.contentSelect.save();
    } catch (e) {
      window.console.error(e);
    }
  }

  private dispose(props: Props) {
    try {
      props.dependency.contentSelect.dispose();
    } catch (err) {
      window.console.error(err);
    }
  }

  private async productNextPage(): Promise<PageInfo> {
    return this.props.dependency.contentSelect.productNextPage();
  }

  private async productSearchChanged(searchParams: SearchProductType) {
    const currentStore = this.props.state.currentStore;

    if (!currentStore) {
      throw new Error('It is cannot have reach here.');
    }

    await this.props.dependency.contentSelect.searchProducts(
      currentStore.id,
      searchParams,
    );
  }
}

export default ContentSelectRoute;
